import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";

import { MOBILE_BREAKPOINT_PX } from "../hooks/useIsMobile";

export function AppToaster() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT_PX,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX}px)`);
    const handler = () => setIsMobile(mq.matches);
    handler();
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return (
    <Toaster
      position={isMobile ? "top-center" : "top-right"}
      containerStyle={{ zIndex: 10050 }}
      toastOptions={{ style: { zIndex: 10050 } }}
    />
  );
}
